"use client";

import React from "react";
import { Plus } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const cookiePurposes = [{
  id: "essential",
  title: "Essential Operations",
  description: "These cookies are strictly necessary to provide you with services available through our website and to use some of its features, such as access to secure areas and core functionality."
}, {
  id: "performance",
  title: "Performance & Analytics",
  description: "These cookies collect information that is used either in aggregate form to help us understand how our website is being used or how effective our marketing campaigns are, allowing us to continuously improve the user experience."
}, {
  id: "functional",
  title: "Functional Enhancements",
  description: "These cookies are used to enhance the performance and functionality of our website but are non-essential to their use. However, without these cookies, certain personalized functionality may become unavailable."
}, {
  id: "targeting",
  title: "Targeting & Advertising",
  description: "These cookies are used to make advertising messages more relevant to you. They perform functions like preventing the same ad from continuously reappearing, ensuring that ads are properly displayed, and selecting advertisements based on your interests."
}];
export default function PurposeOfCookies() {
  return <section id="purpose-of-cookies" className="w-full py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6 max-w-3xl">
        <div className="mb-12 text-center">
          <h2 className="text-3xl md:text-4xl font-serif font-bold tracking-tight mb-4">
            Purpose of Cookies
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto font-sans">
            We use different types of cookies to optimize your experience. Below is a detailed breakdown of how and why we utilize them.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-4">
          {cookiePurposes.map((item, i) => <AccordionItem key={item.id} value={item.id} data-index={i} className="border border-secondary rounded-none overflow-hidden group/item transition-all duration-300 data-[state=open]:bg-primary/95 data-[state=open]:backdrop-blur-md data-[state=open]:shadow-xl">
              <AccordionTrigger className="group [&>svg]:hidden hover:no-underline px-6 py-5 transition-all duration-300 outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background">
                <div className="flex items-center justify-between w-full text-left gap-4">
                  <span className="font-serif font-semibold text-lg tracking-tight text-foreground group-data-[state=open]/item:text-primary-foreground transition-colors duration-300">
                    {item.title}
                  </span>
                  <Plus strokeWidth={2} strokeLinecap="square" strokeLinejoin="miter" className="size-5 shrink-0 text-foreground group-data-[state=open]/item:text-primary-foreground transition-all duration-300 group-data-[state=open]/item:rotate-45" />
                </div>
              </AccordionTrigger>
              <AccordionContent className="px-6 pb-6 pt-0">
                <p className="text-base leading-relaxed font-sans text-primary-foreground/80">
                  {item.description}
                </p>
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}